import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { getAccountId, getFacilityId } from "../../utilis/facilityStorage";
import { refreshManager } from "../../services/auth/refreshManager";

const baseURL = process.env.REACT_APP_BASE_URL;

// Helper to get CSRF token from cookies
const getCsrfTokenFromCookie = () => {
  return Cookies.get("__Secure-CSRF-Token") || Cookies.get("CSRF-Token");
};

const baseQuery = fetchBaseQuery({
  baseUrl: baseURL,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const token = sessionStorage.getItem("x-auth");
    const state = getState();
    const accountId = state.activeFacilities?.accountId || getAccountId();
    const facilityId = state.activeFacilities?.facilityId || getFacilityId();

    if (token) {
      headers.set("x-auth", token);
    }
    if (accountId) {
      headers.set("accountId", accountId);
    }
    if (facilityId) {
      headers.set("facilityId", facilityId);
    }

    // Add CSRF token for non-safe methods (POST, PUT, DELETE, PATCH)
    const csrfToken = getCsrfTokenFromCookie();
    if (csrfToken) {
      headers.set("X-CSRF-Token", csrfToken);
    }

    return headers;
  },
});

// Wrapper for token refresh logic
const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    const errorCode = result?.error?.data?.code || result?.error?.data?.errorCode;

    // Handle session compromised - no retry, redirect immediately
    if (errorCode === 'SESSION_COMPROMISED') {
      sessionStorage.clear();
      window.location.href = "/login";
      return result;
    }

    try {
      // Use shared refresh manager instead of direct call
      await refreshManager.refresh();

      // Retry the original request
      result = await baseQuery(args, api, extraOptions);
    } catch (refreshError) {
      sessionStorage.clear();
      window.location.href = "/login";
    }
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "User",
    "Facility",
    "Account",
    "Admission",
    "Hospital",
    "Filter",
    "Role",
    "Note",
    "CommunityTransfer",
    "Deceased",
    "Permission",
  ],
  endpoints: () => ({}),
});
